import Field from '../Field';
export { ErrorText, StyledLabel } from '../Field';
export default Field;
